import { useOfferContext } from '../../../../context';
import { Button, Heart16, HeartStroke16, TooltipDesktop } from '@cian/ui-kit';
import * as React from 'react';

import { ControlWrapper } from '../../../../components/ControlWrapper';

export function FavoritesControlContainer() {
  const {
    offer,
    api: { onFavoritesChange },
  } = useOfferContext();

  const [isFavorite, setFavorite] = React.useState(Boolean(offer.isFavorite));

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onFavoritesChange(!Boolean(isFavorite));
    setFavorite(!isFavorite);
  };

  return (
    <ControlWrapper visible={isFavorite}>
      <TooltipDesktop theme="black" placement="left" title={isFavorite ? 'В избранном' : 'Добавить в избранное'}>
        <Button
          data-mark="FavoritesControl"
          size="XS"
          theme="stroke_secondary"
          onClick={handleClick}
          beforeIcon={isFavorite ? <Heart16 color="error_100" /> : <HeartStroke16 />}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
}
